import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";

import { auth, db, functions } from "../Config/firebase";
import Navbar from "../Components/Navbar/navbar";
import ListaUsuarios, {
  labelTipoUsuario,
  planoUsuario,
} from "../Components/ListaUsuarios/listausuarios";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import { getUsuarioAtualComTenant, tenantWhere , consultaTenantAtual} from "../Utils/tenant";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ACESSOS_ADMIN_AUXILIAR, usePermissoesAcesso } from "../Utils/permissoesAcesso";

function dataParaInput(valor) {
  if (!valor) return "";
  const data = valor.toDate ? valor.toDate() : new Date(valor.seconds ? valor.seconds * 1000 : valor);
  if (Number.isNaN(data.getTime())) return "";
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

const PLANOS_SAAS = {
  pessoal: { nome: "Pessoal", limiteUsuarios: 1, limiteObras: 0 },
  essencial: { nome: "Essencial", limiteUsuarios: 5, limiteObras: 3 },
  profissional: { nome: "Profissional", limiteUsuarios: 20, limiteObras: 15 },
  corporativo: { nome: "Corporativo", limiteUsuarios: 50, limiteObras: 0 },
};

function vencimentoPadrao(cicloCobranca) {
  const data = new Date();
  if (cicloCobranca === "anual") data.setFullYear(data.getFullYear() + 1);
  else data.setDate(data.getDate() + 30);
  return dataParaInput(data);
}

function CadastroUsuarios({ open, isMobile }) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("qualinfra");
  const [tipo, setTipo] = useState("cliente");
  const [tenantNome, setTenantNome] = useState("");
  const [perfilSaas, setPerfilSaas] = useState("adminsaas");
  const [obrasDisponiveis, setObrasDisponiveis] = useState([]);
  const [obrasSelecionadas, setObrasSelecionadas] = useState([]);
  const [buscaObraCadastro, setBuscaObraCadastro] = useState("");

  const [openCadastro, setOpenCadastro] = useState(false);
  const [openEditar, setOpenEditar] = useState(false);
  const [openGerenciarTenant, setOpenGerenciarTenant] = useState(false);
  const [openGerenciarPlano, setOpenGerenciarPlano] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [permissoesEdicao, setPermissoesEdicao] = useState({});
  const { adminPrincipal } = usePermissoesAcesso();
  const [adminTenantEditando, setAdminTenantEditando] = useState(null);
  const [obrasEdicao, setObrasEdicao] = useState([]);
  const [buscaObraEdicao, setBuscaObraEdicao] = useState("");
  const [tipoEdicao, setTipoEdicao] = useState("colaborador");
  const [tenantNomeEdicao, setTenantNomeEdicao] = useState("");
  const [clientePlanoEditando, setClientePlanoEditando] = useState(null);
  const [vencimentoMensal, setVencimentoMensal] = useState("");
  const [cicloCobranca, setCicloCobranca] = useState("mensal");
  const [planoSaas, setPlanoSaas] = useState("essencial");
  const [limiteUsuarios, setLimiteUsuarios] = useState(5);
  const [limiteObras, setLimiteObras] = useState(3);

  const [usuarios, setUsuarios] = useState([]);
  const [carregandoUsuarios, setCarregandoUsuarios] = useState(true);
  const [busca, setBusca] = useState("");
  const [buscaDebounce, setBuscaDebounce] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroTipo, setFiltroTipo] = useState("todos");
  const [filtroPlano, setFiltroPlano] = useState("todos");

  const [msg, setMsg] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [salvandoEdicao, setSalvandoEdicao] = useState(false);
  const [migrandoTenant, setMigrandoTenant] = useState(false);
  const [salvandoPlano, setSalvandoPlano] = useState(false);

  const [authReady, setAuthReady] = useState(false);
  const [claims, setClaims] = useState(null);
  const [usuarioAtual, setUsuarioAtual] = useState(null);

  const criarUsuario = useMemo(
    () => httpsCallable(functions, "criarUsuario"),
    []
  );
  const atualizarObrasUsuarioFn = useMemo(
    () => httpsCallable(functions, "atualizarObrasUsuario"),
    []
  );
  const atualizarTipoUsuarioFn = useMemo(
    () => httpsCallable(functions, "atualizarTipoUsuario"),
    []
  );
  const alterarStatusUsuarioFn = useMemo(
    () => httpsCallable(functions, "alterarStatusUsuario"),
    []
  );
  const migrarLegadoParaTenantFn = useMemo(
    () => httpsCallable(functions, "migrarLegadoParaTenant"),
    []
  );
  const atualizarPlanoTenantFn = useMemo(
    () => httpsCallable(functions, "atualizarPlanoTenant"),
    []
  );
  const obrasFiltradasCadastro = useMemo(() => {
    const termo = buscaObraCadastro.trim().toLocaleLowerCase("pt-BR");
    if (!termo) return obrasDisponiveis;

    return obrasDisponiveis.filter((obra) =>
      [obra.nome, obra.clienteNome].some((campo) =>
        contemTextoPesquisa(String(campo || "").toLocaleLowerCase("pt-BR"), termo)
      )
    );
  }, [buscaObraCadastro, obrasDisponiveis]);

  const obrasFiltradasEdicao = useMemo(() => {
    const termo = buscaObraEdicao.trim().toLocaleLowerCase("pt-BR");
    if (!termo) return obrasDisponiveis;

    return obrasDisponiveis.filter((obra) =>
      [obra.nome, obra.clienteNome].some((campo) =>
        contemTextoPesquisa(String(campo || "").toLocaleLowerCase("pt-BR"), termo)
      )
    );
  }, [buscaObraEdicao, obrasDisponiveis]);

  function toggleObra(id) {
    setObrasSelecionadas((prev) =>
      prev.includes(id) ? prev.filter((obraId) => obraId !== id) : [...prev, id]
    );
  }

  function abrirEdicao(usuario) {
    if (usuarioAtual?.isSuperadmin && usuario.tipo === "admin") {
      abrirGerenciamentoTenant(usuario);
      return;
    }

    setErro("");
    setMsg("");
    setUsuarioEditando(usuario);
    setPermissoesEdicao(usuario.permissoesAcesso || {});
    setObrasEdicao(usuario.obras || []);
    setBuscaObraEdicao("");
    setTipoEdicao(usuario.tipo || "colaborador");
    setOpenEditar(true);
  }

  function abrirGerenciamentoTenant(usuario) {
    setErro("");
    setMsg("");
    setAdminTenantEditando(usuario);
    setTenantNomeEdicao(usuario.tenantNome || usuario.nome || "");
    setOpenGerenciarTenant(true);
  }

  function abrirGerenciamentoPlano(usuario) {
    setErro("");
    setMsg("");
    setClientePlanoEditando(usuario);
    const cicloAtual = ["mensal", "anual"].includes(usuario.cicloCobranca)
      ? usuario.cicloCobranca
      : (["mensal", "anual"].includes(usuario.plano) ? usuario.plano : "mensal");
    const planoAtual = PLANOS_SAAS[usuario.planoSaas] ? usuario.planoSaas : "essencial";
    const padrao = PLANOS_SAAS[planoAtual];
    setCicloCobranca(cicloAtual);
    setPlanoSaas(planoAtual);
    setLimiteUsuarios(Number(usuario.limiteUsuarios) || padrao.limiteUsuarios);
    setLimiteObras(Number.isFinite(Number(usuario.limiteObras))
      ? Number(usuario.limiteObras)
      : padrao.limiteObras);
    setVencimentoMensal(
      dataParaInput(usuario.assinaturaExpiraEm) || vencimentoPadrao(cicloAtual)
    );
    setOpenGerenciarPlano(true);
  }

  function selecionarPlanoSaas(novoPlano) {
    const padrao = PLANOS_SAAS[novoPlano];
    setPlanoSaas(novoPlano);
    setLimiteUsuarios(padrao.limiteUsuarios);
    setLimiteObras(padrao.limiteObras);
  }

  function selecionarCicloCobranca(novoCiclo) {
    setCicloCobranca(novoCiclo);
    setVencimentoMensal(vencimentoPadrao(novoCiclo));
  }

  function toggleObraEdicao(id) {
    setObrasEdicao((prev) =>
      prev.includes(id) ? prev.filter((obraId) => obraId !== id) : [...prev, id]
    );
  }

  function tituloPagina() {
    return usuarioAtual?.isSuperadmin ? "Clientes SaaS" : "Cadastro de Usuários";
  }

  function abrirCadastroUsuario() {
    setErro("");
    setMsg("");
    setNome("");
    setEmail("");
    setSenha("qualinfra");
    setTenantNome("");
    setPerfilSaas("adminsaas");
    setObrasSelecionadas([]);
    setBuscaObraCadastro("");
    setTipo(usuarioAtual?.isSuperadmin ? "admin" : "cliente");
    setOpenCadastro(true);
  }

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdTokenResult(true);
        setClaims(token.claims);
        setUsuarioAtual(await getUsuarioAtualComTenant());
      }
      setAuthReady(true);
    });

    return () => unsub();
  }, []);

  async function carregarUsuarios() {
    setCarregandoUsuarios(true);
    try {
    const usuariosQuery = query(
      collection(db, "users"),
      ...tenantWhere(usuarioAtual),
      orderBy("nome", "asc")
    );
    const snap = await getDocs(consultaTenantAtual(usuariosQuery));
    const listaUsuarios = snap.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));

    if (usuarioAtual?.isSuperadmin) {
      const usuariosPorTenant = listaUsuarios.reduce((grupos, usuario) => {
        if (!usuario.tenantId) return grupos;
        if (!grupos.has(usuario.tenantId)) grupos.set(usuario.tenantId, []);
        grupos.get(usuario.tenantId).push(usuario);
        return grupos;
      }, new Map());

      const principaisPorTenant = new Map();
      usuariosPorTenant.forEach((usuariosTenant, tenantId) => {
        const adminsPorCriacao = usuariosTenant
          .filter((usuario) => usuario.tipo === "admin")
          .sort((a, b) => {
            const dataA = a.criadoEm?.toMillis?.() || a.criadoEm?.seconds || 0;
            const dataB = b.criadoEm?.toMillis?.() || b.criadoEm?.seconds || 0;
            return dataA - dataB;
          });
        const principal =
          usuariosTenant.find((usuario) => usuario.adminPrincipal === true) ||
          adminsPorCriacao[0];
        if (principal) principaisPorTenant.set(tenantId, principal.id);
      });

      setUsuarios(listaUsuarios.map((usuario) => ({
        ...usuario,
        adminPrincipal:
          usuario.tipo === "admin" &&
          principaisPorTenant.get(usuario.tenantId) === usuario.id,
      })));
      return;
    }

    let adminPrincipalId = "";
    if (usuarioAtual?.tenantId) {
      const tenantSnap = await getDoc(doc(db, "tenants", usuarioAtual.tenantId));
      adminPrincipalId = tenantSnap.exists() ? tenantSnap.data().adminPrincipalId || "" : "";
    }
    if (!adminPrincipalId) {
      const adminsPorCriacao = listaUsuarios
        .filter((usuario) => usuario.tipo === "admin")
        .sort((a, b) => {
          const dataA = a.criadoEm?.toMillis?.() || a.criadoEm?.seconds || 0;
          const dataB = b.criadoEm?.toMillis?.() || b.criadoEm?.seconds || 0;
          return dataA - dataB;
        });
      adminPrincipalId =
        listaUsuarios.find((usuario) => usuario.adminPrincipal === true)?.id ||
        adminsPorCriacao[0]?.id ||
        "";
    }
    setUsuarios(listaUsuarios.map((usuario) => ({
      ...usuario,
      adminPrincipal: usuario.id === adminPrincipalId,
    })));
    } finally {
      setCarregandoUsuarios(false);
    }
  }

  useEffect(() => {
    async function carregarObras() {
      const snap = await getDocs(
        query(
          collection(db, "obras"),
          ...tenantWhere(usuarioAtual),
          orderBy("nome", "asc")
        )
      );
      setObrasDisponiveis(
        snap.docs
          .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
          .filter((obra) => obra.ativo !== false)
      );
    }

    if (usuarioAtual) carregarObras();
  }, [usuarioAtual]);

  useEffect(() => {
    if (usuarioAtual?.isAdmin || usuarioAtual?.isSuperadmin) {
      carregarUsuarios();
    }
  }, [claims, usuarioAtual]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBuscaDebounce(busca);
    }, 400);

    return () => clearTimeout(timer);
  }, [busca]);

  const usuariosFiltrados = useMemo(() => {
    const correspondentes = usuarios.filter((usuario) => {
      const texto = `
        ${usuario.nome}
        ${usuario.email}
        ${labelTipoUsuario(usuario)}
        ${usuario.tenantNome || usuario.tenantId || ""}
        ${planoUsuario(usuario).label}
      `.toLocaleLowerCase("pt-BR");

      const statusOk =
        filtroStatus === "todos" || usuario.status === filtroStatus;
      const tipoOk =
        !usuarioAtual?.isSuperadmin ||
        filtroTipo === "todos" ||
        labelTipoUsuario(usuario) === filtroTipo;
      const planoOk =
        !usuarioAtual?.isSuperadmin ||
        filtroPlano === "todos" ||
        planoUsuario(usuario).label === filtroPlano;

      return (
        contemTextoPesquisa(texto, buscaDebounce.toLocaleLowerCase("pt-BR")) &&
        statusOk &&
        tipoOk &&
        planoOk
      );
    });

    if (!usuarioAtual?.isSuperadmin) return correspondentes;

    const idsCorrespondentes = new Set(correspondentes.map((usuario) => usuario.id));
    const tenantsCorrespondentes = new Set(
      correspondentes.map((usuario) => usuario.tenantId).filter(Boolean)
    );

    return usuarios.filter((usuario) =>
      idsCorrespondentes.has(usuario.id) ||
      (usuario.adminPrincipal && tenantsCorrespondentes.has(usuario.tenantId))
    );
  }, [usuarios, buscaDebounce, filtroStatus, filtroTipo, filtroPlano, usuarioAtual]);

  const tiposDisponiveis = useMemo(
    () => [...new Set(usuarios.map(labelTipoUsuario))].sort((a, b) =>
      a.localeCompare(b, "pt-BR", { sensitivity: "base" })
    ),
    [usuarios]
  );

  const planosDisponiveis = useMemo(
    () => [...new Set(usuarios.map((usuario) => planoUsuario(usuario).label))]
      .filter((plano) => plano !== "-")
      .sort((a, b) => a.localeCompare(b, "pt-BR", { sensitivity: "base" })),
    [usuarios]
  );

  async function cadastrar(event) {
    event.preventDefault();
    setErro("");
    setMsg("");

    if (tipo === "cliente" && obrasSelecionadas.length === 0) {
      setErro("Cliente precisa ter pelo menos uma obra vinculada.");
      return;
    }

    setLoading(true);

    try {
      await criarUsuario({
        nome,
        email,
        senha,
        tipo,
        tenantNome: usuarioAtual?.isSuperadmin && tipo === "admin" ? tenantNome : "",
        perfilSaas: usuarioAtual?.isSuperadmin ? perfilSaas : "",
        obras: tipo === "cliente" ? obrasSelecionadas : [],
      });

      setMsg("Usuário cadastrado com sucesso!");
      setNome("");
      setEmail("");
      setSenha("qualinfra");
      setTipo(usuarioAtual?.isSuperadmin ? "admin" : "cliente");
      setTenantNome("");
      setPerfilSaas("adminsaas");
      setObrasSelecionadas([]);
      setOpenCadastro(false);

      await carregarUsuarios();
    } catch (err) {
      if (err?.code === "functions/already-exists" || /email-already-exists|e-mail j[aá] est[aá] cadastrado/i.test(String(err?.message || ""))) {
        setErro("Já existe um usuário cadastrado com este e-mail.");
      } else {
        setErro(err?.message || "Erro ao cadastrar usuário.");
      }
    } finally {
      setLoading(false);
    }
  }

  async function alterarStatusUsuario(id, novoStatus) {
    try {
      await alterarStatusUsuarioFn({
        usuarioId: id,
        status: novoStatus,
      });

      setUsuarios((prev) =>
        prev.map((usuario) =>
          usuario.id === id ? { ...usuario, status: novoStatus } : usuario
        )
      );
    } catch (err) {
      setErro(err?.message || "Erro ao alterar status do usuário.");
    }
  }

  async function salvarPlanoAssinatura(event) {
    event.preventDefault();
    if (!clientePlanoEditando || !vencimentoMensal || !planoSaas || !cicloCobranca) return;

    setErro("");
    setMsg("");
    setSalvandoPlano(true);
    try {
      const resultado = await atualizarPlanoTenantFn({
        usuarioId: clientePlanoEditando.id,
        vencimento: vencimentoMensal,
        cicloCobranca,
        planoSaas,
        limiteUsuarios: Number(limiteUsuarios),
        limiteObras: Number(limiteObras),
      });
      setUsuarios((prev) => prev.map((usuario) =>
        usuario.tenantId === clientePlanoEditando.tenantId
          ? {
              ...usuario,
              plano: cicloCobranca,
              cicloCobranca,
              planoSaas,
              limiteUsuarios: Number(limiteUsuarios),
              limiteObras: Number(limiteObras),
              perfilSaas: planoSaas === "pessoal" ? "adminsaasPessoal" : "adminsaas",
              assinaturaExpiraEm: resultado.data.assinaturaExpiraEm,
              demonstracaoExpiraEm: null,
              status: usuario.status === "demonstracao" ? "ativo" : usuario.status,
            }
          : usuario
      ));
      setOpenGerenciarPlano(false);
      setClientePlanoEditando(null);
      setMsg("Plano e limites atualizados com sucesso.");
    } catch (err) {
      setErro(err.message || "Erro ao atualizar o plano.");
    } finally {
      setSalvandoPlano(false);
    }
  }

  async function salvarEdicaoObras() {
    if (!usuarioEditando) {
      return;
    }

    setErro("");
    setMsg("");
    setSalvandoEdicao(true);

    try {
      if (usuarioEditando.tipo === "cliente") {
        await atualizarObrasUsuarioFn({
          usuarioId: usuarioEditando.id,
          obras: obrasEdicao,
        });
      }

      if (
        ["admin", "colaborador"].includes(usuarioEditando.tipo) &&
        tipoEdicao !== usuarioEditando.tipo
      ) {
        await atualizarTipoUsuarioFn({
          usuarioId: usuarioEditando.id,
          tipo: tipoEdicao,
        });
      }

      const permissoesSalvas = tipoEdicao === "colaborador"
        ? { dosagemEditar: permissoesEdicao.dosagemEditar === true }
        : Object.fromEntries(ACESSOS_ADMIN_AUXILIAR.map(({ id }) => [id, permissoesEdicao[id] === true]));
      if (adminPrincipal && ["admin", "colaborador"].includes(tipoEdicao) &&
          usuarioEditando.id !== auth.currentUser?.uid && !usuarioEditando.adminPrincipal) {
        await httpsCallable(functions, "atualizarPermissoesUsuario")({
          usuarioId: usuarioEditando.id,
          permissoesAcesso: permissoesSalvas,
        });
      }

      setUsuarios((prev) =>
        prev.map((usuario) =>
          usuario.id === usuarioEditando.id
            ? {
                ...usuario,
                tipo: tipoEdicao,
                permissoesAcesso: adminPrincipal ? permissoesSalvas : usuario.permissoesAcesso || {},
                obras: tipoEdicao === "cliente" ? obrasEdicao : [],
              }
            : usuario
        )
      );

      setOpenEditar(false);
      setUsuarioEditando(null);
      setMsg("Usuário salvo com sucesso!");
    } catch (error) {
      setErro(error?.message || "Erro ao atualizar o usuário.");
    } finally {
      setSalvandoEdicao(false);
    }
  }

  async function migrarDadosLegadosParaTenant() {
    if (!adminTenantEditando) return;

    const confirmar = await confirmarSistema(
      "Esta ação vai vincular todos os usuários e cadastros antigos sem tenantId a este cliente SaaS. Continuar?"
    );

    if (!confirmar) return;

    setErro("");
    setMsg("");
    setMigrandoTenant(true);

    try {
      const resultado = await migrarLegadoParaTenantFn({
        adminUsuarioId: adminTenantEditando.id,
        tenantNome: tenantNomeEdicao,
      });

      setMsg(
        `Migração concluída. Usuários atualizados: ${resultado.data.usuariosAtualizados}. Documentos atualizados: ${resultado.data.docsAtualizados}.`
      );
      setOpenGerenciarTenant(false);
      setAdminTenantEditando(null);
      await carregarUsuarios();
    } catch (err) {
      setErro(err.message || "Erro ao migrar dados legados.");
    } finally {
      setMigrandoTenant(false);
    }
  }

  if (!authReady) return null;
  if (!usuarioAtual?.isAdmin && !usuarioAtual?.isSuperadmin) return <div>Apenas administradores</div>;
  if (
    !usuarioAtual?.isSuperadmin &&
    (usuarioAtual?.plano === "pessoal" || usuarioAtual?.perfilSaas === "adminsaasPessoal")
  ) {
    return (
      <>
        <Navbar open={open} isMobile={isMobile} />
        <div className="container" style={{ marginTop: 100 }}>
          <div className="alert alert-info">
            O plano Pessoal permite somente um acesso e não possui cadastro de usuários adicionais.
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar open={open} isMobile={isMobile} />

      <div className="container" style={{ marginTop: 100 }}>
        <div className="cabecalho-lista-cadastro">
        <h3>{tituloPagina()}</h3>
        {usuarioAtual?.isSuperadmin && (
          <div className="alert alert-info">
            Você está como superadmin. Aqui você cadastra o cliente SaaS e o
            admin principal dele. Depois esse admin cria os usuários internos,
            clientes finais e obras dentro da própria conta.
          </div>
        )}
        {!usuarioAtual?.isSuperadmin && (
          <div className="alert alert-warning">
            Segurança: é responsabilidade dos administradores desativar imediatamente o acesso de colaboradores que se desligaram ou estão se desvinculando da empresa.
          </div>
        )}
        <hr />

        {msg && <div className="alert alert-success">{msg}</div>}
        {erro && !openCadastro && !openEditar && <div className="alert alert-danger">{erro}</div>}

        <div className="row mb-3 align-items-end">
          <div className="col">
            <input
              className="form-control"
              placeholder="Pesquisar usuário..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </div>

          <div className="col-auto">
            <select
              className="form-control"
              value={filtroStatus}
              onChange={(e) => setFiltroStatus(e.target.value)}
            >
              <option value="todos">Todos</option>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
            </select>
          </div>

          {usuarioAtual?.isSuperadmin && (
            <div className="col-auto">
              <select
                className="form-control"
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
                aria-label="Filtrar por tipo"
              >
                <option value="todos">Todos os tipos</option>
                {tiposDisponiveis.map((tipoUsuario) => (
                  <option key={tipoUsuario} value={tipoUsuario}>{tipoUsuario}</option>
                ))}
              </select>
            </div>
          )}

          {usuarioAtual?.isSuperadmin && (
            <div className="col-auto">
              <select
                className="form-control"
                value={filtroPlano}
                onChange={(e) => setFiltroPlano(e.target.value)}
                aria-label="Filtrar por plano"
              >
                <option value="todos">Todos os planos</option>
                {planosDisponiveis.map((plano) => (
                  <option key={plano} value={plano}>{plano}</option>
                ))}
              </select>
            </div>
          )}

          <div className="col-auto">
            <button
              className="btn btn-primary"
              onClick={abrirCadastroUsuario}
            >
              {usuarioAtual?.isSuperadmin ? "Cadastrar cliente SaaS" : "Cadastrar"}
            </button>
          </div>
        </div>
        </div>

        {carregandoUsuarios ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}>
            <CircularProgress />
            <Typography color="text.secondary">Carregando usuários...</Typography>
          </Box>
        ) : (
          <ListaUsuarios
            usuarios={usuariosFiltrados}
            alterarStatus={alterarStatusUsuario}
            editarUsuario={abrirEdicao}
            gerenciarTenant={abrirGerenciamentoTenant}
            gerenciarPlano={abrirGerenciamentoPlano}
            mostrarTenant={usuarioAtual?.isSuperadmin}
          />
        )}
      </div>

      {openGerenciarPlano && clientePlanoEditando && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form onSubmit={salvarPlanoAssinatura}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    Gerenciar plano mensal / anual
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => !salvandoPlano && setOpenGerenciarPlano(false)}
                    disabled={salvandoPlano}
                  />
                </div>
                <div className="modal-body">
                  <div className="mb-2"><strong>Cliente:</strong> {clientePlanoEditando.tenantNome || clientePlanoEditando.nome}</div>
                  <div className="mb-3"><strong>Admin principal:</strong> {clientePlanoEditando.email}</div>
                  <label className="form-label fw-bold" htmlFor="ciclo-cobranca">
                    Ciclo de cobranca
                  </label>
                  <select
                    id="ciclo-cobranca"
                    className="form-select mb-3"
                    value={cicloCobranca}
                    onChange={(event) => selecionarCicloCobranca(event.target.value)}
                    disabled={salvandoPlano}
                  >
                    <option value="mensal">Mensal</option>
                    <option value="anual">Anual</option>
                  </select>

                  <label className="form-label fw-bold" htmlFor="plano-saas">
                    Tipo de plano
                  </label>
                  <select
                    id="plano-saas"
                    className="form-select mb-3"
                    value={planoSaas}
                    onChange={(event) => selecionarPlanoSaas(event.target.value)}
                    disabled={salvandoPlano}
                  >
                    {Object.entries(PLANOS_SAAS).map(([valor, plano]) => (
                      <option key={valor} value={valor}>{plano.nome}</option>
                    ))}
                  </select>

                  <div className="row g-2 mb-3">
                    <div className="col-sm-6">
                      <label className="form-label fw-bold" htmlFor="limite-usuarios">
                        Limite de acessos
                      </label>
                      <input
                        id="limite-usuarios"
                        className="form-control"
                        type="number"
                        min="1"
                        step="1"
                        value={limiteUsuarios}
                        onChange={(event) => setLimiteUsuarios(event.target.value)}
                        disabled={salvandoPlano}
                        required
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label fw-bold" htmlFor="limite-obras">
                        Limite de obras
                      </label>
                      <input
                        id="limite-obras"
                        className="form-control"
                        type="number"
                        min="0"
                        step="1"
                        value={limiteObras}
                        onChange={(event) => setLimiteObras(event.target.value)}
                        disabled={salvandoPlano}
                        required
                      />
                      <small className="text-muted">Use 0 para obras ilimitadas.</small>
                    </div>
                  </div>
                  <label className="form-label fw-bold" htmlFor="vencimento-mensal">
                    Vencimento da assinatura
                  </label>
                  <input
                    id="vencimento-mensal"
                    className="form-control"
                    type="date"
                    value={vencimentoMensal}
                    min={dataParaInput(new Date())}
                    onChange={(event) => setVencimentoMensal(event.target.value)}
                    disabled={salvandoPlano}
                    required
                  />
                  <small className="text-muted">
                    O aviso será mostrado no login quando faltarem 5 dias ou menos para esta data.
                  </small>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setOpenGerenciarPlano(false)}
                    disabled={salvandoPlano}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={salvandoPlano || !vencimentoMensal}>
                    {salvandoPlano ? "Salvando..." : "Confirmar plano"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {openCadastro && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <form onSubmit={cadastrar}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {usuarioAtual?.isSuperadmin
                      ? "Cadastrar cliente SaaS / admin principal"
                      : "Cadastrar Usuário"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenCadastro(false)}
                    disabled={loading}
                  />
                </div>

                <div className="modal-body">
                  {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
                  <input
                    className="form-control mb-2"
                    placeholder="Nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    required
                  />
                  <input
                    className="form-control mb-2"
                    placeholder="E-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <input
                    className="form-control mb-2"
                    type="password"
                    placeholder="Senha provisória"
                    value={senha}
                    readOnly
                  />
                  <small className="form-text text-muted d-block mb-2">
                    A senha do primeiro acesso é <strong>qualinfra</strong>. O usuário deverá alterá-la ao entrar no sistema.
                  </small>

                  {usuarioAtual?.isSuperadmin ? (
                    <>
                      <input
                        className="form-control mb-2"
                        value="Admin principal do cliente SaaS"
                        readOnly
                      />
                      <select
                        className="form-control mb-2"
                        value={perfilSaas}
                        onChange={(e) => setPerfilSaas(e.target.value)}
                      >
                        <option value="adminsaas">Admin SaaS</option>
                        <option value="adminsaasPessoal">Admin SaaS Pessoal — 1 acesso</option>
                      </select>
                      {perfilSaas === "adminsaasPessoal" && (
                        <div className="alert alert-warning py-2">
                          Este cliente terá somente o acesso do administrador principal e não poderá cadastrar outros usuários.
                        </div>
                      )}
                    </>
                  ) : (
                    <select
                      className="form-control mb-2"
                      value={tipo}
                      onChange={(e) => setTipo(e.target.value)}
                    >
                      <option value="cliente">Cliente</option>
                      <option value="colaborador">Colaborador</option>      
                      <option value="dp">Departamento Pessoal</option>              
                      <option value="admin">Administrador auxiliar</option>
                    </select>
                  )}

                  {usuarioAtual?.isSuperadmin && (
                    <input
                      className="form-control mb-2"
                      placeholder="Nome da empresa / cliente SaaS"
                      value={tenantNome}
                      onChange={(e) => setTenantNome(e.target.value)}
                      required
                    />
                  )}

                  {tipo === "cliente" && (
                    <>
                      <label className="form-label fw-bold mb-2">
                        Obras vinculadas
                      </label>

                      <input
                        className="form-control mb-2"
                        type="search"
                        placeholder="Pesquisar obra ou cliente"
                        value={buscaObraCadastro}
                        onChange={(e) => setBuscaObraCadastro(e.target.value)}
                      />

                      <div
                        className="border rounded p-2"
                        style={{ maxHeight: 200, overflowY: "auto" }}
                      >
                        {obrasDisponiveis.length === 0 && (
                          <small className="text-muted">Nenhuma obra cadastrada</small>
                        )}

                        {obrasDisponiveis.length > 0 && obrasFiltradasCadastro.length === 0 && (
                          <small className="text-muted">Nenhuma obra encontrada</small>
                        )}

                        {obrasFiltradasCadastro.map((obra) => (
                          <div className="form-check" key={obra.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`obra-${obra.id}`}
                              checked={obrasSelecionadas.includes(obra.id)}
                              onChange={() => toggleObra(obra.id)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`obra-${obra.id}`}
                            >
                              {obra.nome}
                            </label>
                          </div>
                        ))}
                      </div>

                      <small className="text-muted">
                        Selecione uma ou mais obras
                      </small>
                    </>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setOpenCadastro(false)}
                    disabled={loading}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Salvando..." : "Salvar"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {openGerenciarTenant && adminTenantEditando && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Gerenciar cliente SaaS</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => !migrandoTenant && setOpenGerenciarTenant(false)}
                  disabled={migrandoTenant}
                />
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <strong>Admin principal:</strong> {adminTenantEditando.nome}
                </div>
                <div className="mb-3">
                  <strong>E-mail:</strong> {adminTenantEditando.email}
                </div>

                <label className="form-label fw-bold">
                  Nome da empresa / cliente SaaS
                </label>
                <input
                  className="form-control mb-3"
                  value={tenantNomeEdicao}
                  onChange={(e) => setTenantNomeEdicao(e.target.value)}
                  disabled={migrandoTenant}
                />

                <div className="alert alert-warning">
                  Use esta ação para o legado: ela vincula a este cliente SaaS
                  todos os usuários e cadastros antigos que ainda estão sem
                  tenantId. O superadmin não será vinculado.
                </div>

                <div className="small text-muted">
                  Tenant atual: {adminTenantEditando.tenantId || "ainda não criado"}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setOpenGerenciarTenant(false)}
                  disabled={migrandoTenant}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={migrarDadosLegadosParaTenant}
                  disabled={migrandoTenant || !tenantNomeEdicao.trim()}
                >
                  {migrandoTenant ? "Migrando..." : "Vincular dados legados"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {openEditar && usuarioEditando && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Editar usuário - {usuarioEditando.nome}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => !salvandoEdicao && setOpenEditar(false)}
                  disabled={salvandoEdicao}
                />
              </div>

              <div className="modal-body">
                {["admin", "colaborador"].includes(usuarioEditando.tipo) && (
                  <>
                    <label className="form-label fw-bold mb-2">
                      Tipo do usuário
                    </label>
                    <select
                      className="form-select mb-3"
                      value={tipoEdicao}
                      onChange={(event) => setTipoEdicao(event.target.value)}
                      disabled={salvandoEdicao}
                    >
                      <option value="admin">Administrador auxiliar</option>
                      <option value="colaborador">Colaborador</option>
                    </select>
                  </>
                )}

                {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
                {adminPrincipal && ["admin", "colaborador"].includes(tipoEdicao) &&
                  usuarioEditando.id !== auth.currentUser?.uid && !usuarioEditando.adminPrincipal && (
                  <div className="mb-3">
                    <label className="form-label fw-bold">Permissões de acesso</label>
                    {(tipoEdicao === "admin" ? ACESSOS_ADMIN_AUXILIAR : [
                      { id: "dosagemEditar", nome: "Permitir criar e editar dosagens e salvar seus relatórios" },
                    ]).map((acesso) => (
                      <div className="form-check" key={acesso.id}>
                        <input type="checkbox" className="form-check-input"
                          id={`permissao-${acesso.id}`}
                          checked={permissoesEdicao[acesso.id] === true}
                          disabled={salvandoEdicao}
                          onChange={(event) => setPermissoesEdicao((anteriores) => ({
                            ...anteriores, [acesso.id]: event.target.checked,
                          }))}
                        />
                        <label className="form-check-label" htmlFor={`permissao-${acesso.id}`}>{acesso.nome}</label>
                      </div>
                    ))}
                    <small className="text-muted">
                      {tipoEdicao === "colaborador"
                        ? "Desmarcado: o colaborador pode somente visualizar dosagens."
                        : "Marque os módulos permitidos. Desmarque para revogar o acesso."}
                    </small>
                  </div>
                )}

                {usuarioEditando.tipo === "cliente" && (
                  <>
                <label className="form-label fw-bold mb-2">
                  Obras vinculadas
                </label>

                <input
                  className="form-control mb-2"
                  type="search"
                  placeholder="Pesquisar obra ou cliente"
                  value={buscaObraEdicao}
                  onChange={(e) => setBuscaObraEdicao(e.target.value)}
                  disabled={salvandoEdicao}
                />

                <div
                  className="border rounded p-2"
                  style={{ maxHeight: 200, overflowY: "auto" }}
                >
                  {obrasDisponiveis.length === 0 && (
                    <small className="text-muted">Nenhuma obra cadastrada</small>
                  )}

                  {obrasDisponiveis.length > 0 && obrasFiltradasEdicao.length === 0 && (
                    <small className="text-muted">Nenhuma obra encontrada</small>
                  )}

                  {obrasFiltradasEdicao.map((obra) => (
                    <div className="form-check" key={obra.id}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`edit-obra-${obra.id}`}
                        checked={obrasEdicao.includes(obra.id)}
                        onChange={() => toggleObraEdicao(obra.id)}
                        disabled={salvandoEdicao}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`edit-obra-${obra.id}`}
                      >
                        {obra.nome}
                      </label>
                    </div>
                  ))}
                </div>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setOpenEditar(false)}
                  disabled={salvandoEdicao}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={salvarEdicaoObras}
                  disabled={salvandoEdicao}
                >
                  {salvandoEdicao ? "Salvando..." : "Salvar alterações"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CadastroUsuarios;
